const { userObject } = ShawContract;

export const getLoggedUserEmail = () => userObject.Email;
